export const RISK_SURVEY_OVERVIEW = '/risk-survey'
export const RISK_SURVEY_PLANT = '/risk-survey/plant/:upmId'
